const api = {
	listCashiers: '/cashier/listBindedCashiers', // 查看收银机列表
	unbindCashier: '/cashier/unbindCashier', // 解绑收银机
	downloadBindCashierQrCode: '/cashier/downloadBindCashierQrCode', // 下载二维码
	updateCashierName: '/cashier/updateCashierName',  // 更改收银机名称
	getBindCashierQrCodeString: '/cashier/getBindCashierQrCodeString', // 获取绑定收银机的二维码
  listPrinters: '/printer/listPrinters', // 查看打印机列表
  bindPrinter: '/cashier/bindPrinter', // 给收银机绑定云打印机
  unbindPrinter: '/cashier/unbindPrinter', // 给收银机解绑云打印机
};

const routes = {
	'/cashier-manage': '收银机管理'
};

export { api, routes };
